import script from "./esWaitingRoomForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./esWaitingRoomForm.vue?vue&type=script&lang=ts&setup=true"

import "./esWaitingRoomForm.vue?vue&type=style&index=0&id=32eb7dd0&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32eb7dd0"]])

export default __exports__